import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=guest, obj=user
  const [permissions, setPermissions] = useState([]);

  const refresh = async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
      setPermissions(data.permissions || []);
    } catch {
      setUser(false);
      setPermissions([]);
    }
  };

  useEffect(() => {
    refresh();
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.mfa_required) return data;
    setUser(data.user);
    await refresh();
    return data.user;
  };

  const verifyMfa = async (challenge, code, rememberDevice) => {
    const { data } = await api.post("/auth/mfa/verify", { challenge, code, remember_device: rememberDevice });
    setUser(data.user);
    await refresh();
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    setUser(false);
    setPermissions([]);
  };

  const can = (perm) => permissions.includes("all") || permissions.includes(perm);

  return (
    <AuthContext.Provider value={{ user, permissions, login, verifyMfa, logout, refresh, can }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
